let config = {
	serverUrl: 'http://localhost:3000',
	// serverUrl: 'http://10.0.0.88:3000',
	// serverUrl: 'http://testsrvr.beautydiary.shop:3000',
	// serverUrl: 'http://192.168.5.101:3000',
	// serverUrl: 'http://192.168.1.100:3000',
	// serverUrl: 'http://sub-api.securesrvr.io',
	debug: false,
	logoImage: 'bdlogo.png', // Receipt logo
	branchName: 'Beauty Diary', // Name of branch
	// branchName: 'Sayar San Branch', // Name of branch
	// brandPhone: '09 777 289 718', // Sayar San Branch
	brandPhone: '09 777 183 304', // Online
	pageItemsLimit: 20, // Page items limit
	printDelay: 500, // Print delay
	auth_token: 'mU950Z5uRG1PExlT5HZVt5Sm1P1e7SwhKCeg0Ugs'
}

export default config
